// Single source of truth for the macro market-outlook vocabulary on the
// frontend.  Four-state outlook (BULLISH / BEARISH / SIDEWAYS / VOLATILE)
// drives both the badge style and the gate-open boolean served by the
// backend.
//
// Color rationale:
//   * BULLISH  → green   (long bias, tradeable)
//   * BEARISH  → red     (down bias, not tradeable)
//   * SIDEWAYS → amber   (no edge, ambiguous)
//   * VOLATILE → red, with a striped overlay so users can distinguish it from
//     a flat BEARISH read at a glance.  Both are "do not trade" reds, but
//     VOLATILE means "dangerous, conditions changing", not "directional down".
//
// IMPORTANT: tradeability is NOT derived from the outlook on the client.
// The backend computes `tradeable` and the UI must use that boolean directly.

export const MARKET_OUTLOOKS = ['BULLISH', 'BEARISH', 'SIDEWAYS', 'VOLATILE'];

const OUTLOOK_CONFIG = {
  BULLISH:  { badgeClass: 'bg-success',           icon: '📈' },
  BEARISH:  { badgeClass: 'bg-danger',            icon: '📉' },
  SIDEWAYS: { badgeClass: 'bg-warning text-dark', icon: '↔' },
  // Striped overlay class is defined in MarketStatusBadge.vue's scoped
  // styles; keep it here so any future consumer renders it the same way.
  VOLATILE: { badgeClass: 'bg-danger market-outlook-volatile', icon: '⚡' },
};

const FALLBACK = { badgeClass: 'bg-secondary', icon: '—' };

export function getOutlookBadgeClass(outlook) {
  return (OUTLOOK_CONFIG[outlook] || FALLBACK).badgeClass;
}

export function getOutlookIcon(outlook) {
  return (OUTLOOK_CONFIG[outlook] || FALLBACK).icon;
}

export function getOutlookLabel(outlook) {
  if (!outlook) return '— NO DATA';
  return `${getOutlookIcon(outlook)} ${outlook}`;
}
